import { HOME_SEO } from '../components/home/marketingCopy.js';
import { PS_SEO } from './personalStatement.js';
import { FAQ_SEO } from '../components/home/faq.js';

export const SEO_PAGES = [
    { key: 'home', label: 'Home', path: '/home', defaults: HOME_SEO },
    { key: 'personal-statement', label: 'Personal Statements', path: '/personal-statement', defaults: PS_SEO },
    { key: 'faq', label: 'Common Questions', path: '/faq', defaults: FAQ_SEO },
];
export const SEO_LIMITS = { title: 160, description: 320 };
function clean(value, fallback, max) {
    // This editor only accepts plain text. Blank/invalid stored values retain safe defaults.
    if (typeof value !== 'string' || /[<>]/.test(value)) return fallback;
    return value.replace(/\s+/g, ' ').trim().slice(0, max) || fallback;
}
export function resolveSeo(siteText, key) {
    const page = SEO_PAGES.find(p => p.key === key);
    if (!page) throw new Error('Unknown SEO page');
    const saved = { ...siteText?.seo?.[key] };
    if (key === 'home') {
        if (saved.title === 'IGCSE English | Edexcel, OxfordAQA & Cambridge CIE Coming Soon | Between the Lines') delete saved.title;
        if (saved.description === 'IGCSE English study packs with AI essay feedback for Edexcel and OxfordAQA. Cambridge (CIE) English packs coming soon. Explore a free lesson with Danielle.') delete saved.description;
    }
    return {
        title: clean(saved?.title, page.defaults.title, SEO_LIMITS.title),
        description: clean(saved?.description, page.defaults.description, SEO_LIMITS.description),
        canonical: `https://daniellenglish.com${page.path}`,
    };
}
